import styles from '../styles/Spurt.module.css';

// Components
import GoBackSection from '../components/GoBackSection';

// Images
import display from '../images/projects/spurt.png'

export default function Spurt() {
  return (
    <>
      <GoBackSection section="projects"/>
      <div className={styles.container}>
        <div>
          <p style={{fontSize: "32px", fontFamily: "var(--font-Alegreya)", color: "var(--color-darkblue)"}}>
            Spurt - Community Garden App
          </p>
          <p style={{width: "500px"}}>
            The go-to app for managing community gardens aims to tackle the challenges of food insecurity 
            and social inequity, while promoting sustainable practices and initiating your plant journey 
            with a fun and inviting design. Users will be able to share knowledge and resources with other 
            gardeners, as well as learn how to enhance the visual appeal of neighborhoods by transforming 
            vacant lots into attractive green spaces.
          </p>
          <p>
            <span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Role</span>
            Front-end Developer & UX-UI Reseacher
          </p>
          <p>
            <span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Tool used</span>
            React, NodeJS, Photoshop, Illustrator, & Figma. 
          </p>
          <p style={{marginBottom: "30px"}}>
            <span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Period</span>
            Sep. 2023 - Dec 2023
          </p>
          <div className={styles.linkContainer}>
            <a className={styles.button} href='https://github.com/lance-malaga/spurt' target="_blank">View GitHub</a>
            <a 
              className={styles.button} 
              href='https://www.figma.com/proto/PpQY40WOTeG1eDpzE7WVBO/Spurt?kind=proto&node-id=73-5379&page-id=0%3A1&scaling=scale-down&starting-point-node-id=73%3A5314&t=oZSJ9ccRZt3AWyjU-1&type=design' 
              target="_blank"
            >
              View Figma Prototype
            </a>
          </div>
        </div>
        <img className={styles.image} src={display} alt='project-img'/>
      </div>
    </>
  )
}